import React from "react";
import { Card, Table, Typography, Tag, Avatar, Row, Col } from "antd";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import moment from "moment";

const { Title, Text } = Typography;

const CustomerReport = ({ customerData, growthData }) => {
  // Transform data for Recharts
  const chartData =
    growthData?.map((item) => ({
      month: moment(item._id).format("MMM YYYY"),
      "New Customers": item.newCustomers,
    })) || [];

  const columns = [
    {
      title: "Customer",
      dataIndex: "customerName",
      key: "name",
      render: (text, record) => (
        <div className="flex items-center">
          <Avatar src={record.avatar} className="mr-2">
            {text.charAt(0)}
          </Avatar>
          <div>
            <Text strong>{text}</Text>
            <br />
            <Text type="secondary">{record.email}</Text>
          </div>
        </div>
      ),
    },
    {
      title: "Total Spent",
      dataIndex: "totalSpent",
      key: "spent",
      render: (amount) => `$${amount.toFixed(2)}`,
      sorter: (a, b) => a.totalSpent - b.totalSpent,
    },
    {
      title: "Orders",
      dataIndex: "orderCount",
      key: "orders",
      sorter: (a, b) => a.orderCount - b.orderCount,
    },
  ];

  return (
    <div className="space-y-4">
      <Row gutter={16}>
        <Col span={12}>
          <Card title="Customer Growth">
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={chartData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="month" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="New Customers" fill="#8884d8" />
              </BarChart>
            </ResponsiveContainer>
          </Card>
        </Col>
        <Col span={12}>
          <Card title="Customer Metrics">
            <div className="mb-4">
              <Text strong>New Customers:</Text>
              <Title level={4}>{customerData?.newCustomers || 0}</Title>
            </div>
            <div className="mb-4">
              <Text strong>Total Customers:</Text>
              <Title level={4}>{customerData?.totalCustomers || 0}</Title>
            </div>
          </Card>
        </Col>
      </Row>

      <Card title="Top Customers">
        <Table
          columns={columns}
          dataSource={customerData?.topCustomers || []}
          rowKey="customerId"
          pagination={false}
        />
      </Card>
    </div>
  );
};

export default CustomerReport;
